import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const RESET_PATH = '/auth/reset-password';

export function RecoveryRedirect() {
  const { passwordRecoveryActive } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (passwordRecoveryActive && pathname !== RESET_PATH) {
      navigate(RESET_PATH, { replace: true });
    }
  }, [passwordRecoveryActive, pathname, navigate]);

  return null;
}
